export default __webpack_public_path__ + "static/media/github_PNG15.a3b53714.png";